import always from "./always";
import tryCatch from "./tryCatch";

const tryElseIdentity = (toTry) => (value) =>
  tryCatch(toTry, always(value))(value);

export default tryElseIdentity;
